<template>
  <v-container>
    <v-row class="pt-5">
      <v-col cols="12">
        <v-row>
          <v-col>
            <h2>
              <div class="text-center" style="color: white">
                Delete your Infoping account
              </div>
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <label>
              <div class="text-center" style="color: white">
                Follow the instructions below to delete your Infoping account.
              </div></label
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-stepper v-if="showStepper" v-model="stepperStep" vertical>
              <v-stepper-step :complete="stepperStep > 1" step="1">
                Type your cell phone number
                <small>example 0702251743</small>
              </v-stepper-step>

              <v-stepper-content step="1">
                <v-select
                  :items="countryCodes"
                  item-text="label"
                  item-value="value"
                  label="Country"
                  v-model="selectedCountryCode"
                ></v-select>

                <v-text-field
                  v-model="phoneNumber"
                  label="Phone number"
                  required
                  hide
                ></v-text-field>
                <v-btn color="primary" @click="login"> Continue </v-btn>
              </v-stepper-content>

              <v-stepper-step :complete="stepperStep > 2" step="2">
                Type code you received on SMS
              </v-stepper-step>

              <v-stepper-content step="2">
                <v-text-field
                  v-mask="'XX-####'"
                  v-model="smsCode"
                  label="ex FT-3434"
                  required
                  filled
                  hide
                ></v-text-field>
                <v-btn color="primary" @click="verifySmsCode"> Continue </v-btn>
              </v-stepper-content>

              <v-stepper-step :complete="stepperStep > 3" step="3">
                Delete account
                <small></small>
              </v-stepper-step>

              <v-stepper-content step="3">
                <v-btn color="primary" @click="confirmDeleteAccount">
                  Delete account
                </v-btn>
              </v-stepper-content>

              <v-stepper-step :complete="stepperStep > 4" step="4">
                Verify delete account
                <small>Note that it's not possible to revert this action</small>
              </v-stepper-step>

              <v-stepper-content step="4">
                <v-btn color="red" @click="deleteAccount">
                  Delete account
                </v-btn>
              </v-stepper-content>
            </v-stepper>
            <div
              v-if="showDeletedInfoDiv"
              class="text-center"
              style="color: white"
            >
              <h2>You account is now deleted.</h2>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  postToBackend,
  API_INITIATE_LOGIN,
  API_LOGIN_SMS_SEND,
  API_CONFIRM_SMS_CODE,
  API_DELETE,
} from '../api.js';

export default {
  data() {
    return {
      showStepper: true,
      showDeletedInfoDiv: false,
      stepperStep: 1,
      phoneNumber: '',
      smsCode: '',
      session: '',
      countryCodes: [
        {
          value: 'SE',
          label: 'Sverige +46',
        },
        {
          value: 'DK',
          label: 'Denmark +45',
        },
        {
          value: 'FI',
          label: 'Finland +358',
        },
        {
          value: 'UK',
          label: 'United Kingdom +44',
        },
        {
          value: 'NL',
          label: 'Netherlands +31',
        },
        {
          value: 'US',
          label: 'USA +1',
        },
      ],
      selectedCountryCode: [],
    };
  },
  methods: {
    login() {
      //Validera telefonnumret med https://www.npmjs.com/package/awesome-phonenumber
      var awesomePhoneNumber = require('awesome-phonenumber');
      var phoneNumberToValidate = new awesomePhoneNumber(
        this.phoneNumber,
        this.selectedCountryCode
      );

      //console.log('selectedCountryCode', this.selectedCountryCode);
      //console.log('nr för validering', phoneNumberToValidate);
      //console.log('landskod', phoneNumberToValidate.h);

      //console.log(
      //  'Is this',
      //  this.phoneNumber,
      //  'phone number valid?',
      //  phoneNumberToValidate.isValid()
      //);

      if (phoneNumberToValidate.isValid()) {
        //Sätter telenumret till e164 format, exempel +46702251743
        this.phoneNumber = phoneNumberToValidate.g.number.e164;
        //  console.log(this.phoneNumber);

        //Skapar objekt till frågan
        const apiQuestionObject = new Object();
        const Q = new Object();
        Q.phone_number = this.phoneNumber;
        apiQuestionObject.Q = Q;

        postToBackend(API_INITIATE_LOGIN, apiQuestionObject).then(
          (responseFromBackend) => {
            if (responseFromBackend.A.status == '1') {
              postToBackend(API_LOGIN_SMS_SEND, apiQuestionObject);
            }
          }
        );

        //Nästa steg i steppern
        this.stepperStep = 2;
      } else {
        alert('Phone number is not valid, try again');
        this.stepperStep = 1;
      }
    },
    verifySmsCode() {
      const apiQuestionObject = new Object();
      const Q = new Object();
      Q.phone_number = this.phoneNumber;
      Q.code = this.smsCode;
      apiQuestionObject.Q = Q;

      postToBackend(API_CONFIRM_SMS_CODE, apiQuestionObject).then(
        (responseFromBackend) => {
          if (responseFromBackend.A.status == 1) {
            this.session = responseFromBackend.A.session;
            this.stepperStep = 3;
          } else {
            alert('Wrong code, try again');
            this.stepperStep = 2;
            this.smsCode = '';
          }
        }
      );
    },
    confirmDeleteAccount() {
      this.stepperStep = 4;
    },
    deleteAccount() {
      const apiQuestionObject = new Object();
      const Q = new Object();
      Q.session = this.session;
      apiQuestionObject.Q = Q;

      postToBackend(API_DELETE, apiQuestionObject).then(
        (responseFromBackend) => {
          //    console.log(
          //      'Response from backend on Delete account',
          //      responseFromBackend
          //    );

          if (
            responseFromBackend &&
            responseFromBackend.A &&
            responseFromBackend.A.status == 0
          ) {
            alert(
              'Not possible to delete account. Contact support@infoping.net or try again.'
            );
            this.phoneNumber = '';
            this.smsCode = '';
            this.session = '';
          } else {
            this.showStepper = false;
            this.showDeletedInfoDiv = true;
          }
        }
      );
    },
  },
};
</script>
